namespace $.$$ {
	export class $shm_showcase_demo_button_copy extends $.$shm_showcase_demo_button_copy {

		@ $mol_mem
		copy_blobs() {
			return [ new Blob( [ 'Текст из $shm_button_copy' ], { type: 'text/plain' } ) ]
		}

	}
}
